import React from 'react';
import PropTypes from 'prop-types';
import arrowIcon from '../../../styles/images/info_bubble_arrow.svg';
import styles from './InfoBubble.module.scss';

/**
 * Info Bubble - white callout with an upward arrow on its top-left edge.
 * Figma: "Info Bubble" (ABO Academy Web, node 28769:136775)
 */
const InfoBubble = ({ children, id, className = '', ...rest }) => (
  <div id={id} role="tooltip" className={`${styles.infoBubble} ${className}`} {...rest}>
    <img src={arrowIcon} alt="" width="24" height="14" className={styles.arrow} />
    <div className={styles.body}>
      <p className={styles.text}>{children}</p>
    </div>
  </div>
);

InfoBubble.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  className: PropTypes.string,
};

export default InfoBubble;
